export default __webpack_public_path__ + "static/media/sample-background.11587ddb.png";